// Formattazione numerica globale Orbit (solo display, nessun arrotondamento dei dati persistiti).
// Regola: rimuove la parte decimale se pari a zero (3,0 -> 3) e mantiene i decimali
// significativi in formato italiano con virgola (1,5 / 2,25). Vuoto/null -> "".
export function fmtNum(value) {
  if (value === null || value === undefined || value === "") return "";
  const n = typeof value === "number" ? value : Number(String(value).replace(",", "."));
  if (!Number.isFinite(n)) return String(value);
  const s = n.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
  return s.replace(".", ",");
}
